document.querySelector('.language-switcher__link').addEventListener('click', function (e) {
  e.preventDefault();

  const { hash } = document.location;
  const href = this.getAttribute('href').split('#')[0];
  window.location.href = `${href}${hash}`;
});
